module.exports = __webpack_public_path__ + "img/PLUS.0830c600.png";